import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDrop } from 'react-dnd';
import { toast } from 'react-toastify';
import TaskCard from '../TaskCard/TaskCard';
const KanbanColumn = ({ taskState, tasks, onAdvanceTask, loading, onChangeState, className, }) => {
    const columnSequence = typeof taskState.process_sequence === 'number' && !Number.isNaN(taskState.process_sequence)
        ? taskState.process_sequence
        : null;
    const isStandby = columnSequence === -1;
    const [{ isOver, canDrop }, dropRef] = useDrop({
        accept: 'TASK',
        // Quand on lâche :
        drop: (draggedTask) => {
            // on accepte toujours pour “on_standby”, sinon on vérifie la suite classique
            if (isStandby ||
                draggedTask.status?.process_sequence === -1 ||
                Math.abs((draggedTask.status?.process_sequence ?? 0) - (columnSequence ?? 0)) === 1) {
                onChangeState(draggedTask.id, taskState.code)
                    .then(() => {
                    toast.success("État de la tâche mis à jour");
                })
                    .catch((error) => {
                    toast.error(`Erreur : ${error.message}`);
                });
            }
        },
        // Pour savoir si on peut lâcher
        canDrop: (draggedTask) => {
            // 1) colonne avec process_sequence = -1 : on accepte TOUT
            if (isStandby)
                return true;
            // 2) déplacement depuis process_sequence = -1 : on accepte TOUT
            if (draggedTask.status?.process_sequence === -1)
                return true;
            // 3) sinon, on n’accepte que les séquences adjacentes
            return Math.abs((draggedTask.status?.process_sequence ?? 0) - (columnSequence ?? 0)) === 1;
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    const tasksState = tasks.filter(task => task.status?.code === taskState.code);
    const borderStyle = isOver && canDrop
        ? 'border-dotted border-2 border-blue-500 transition-all duration-300 bg-blue-50'
        : 'border-transparent bg-white';
    return (_jsxs("div", { ref: dropRef, className: `flex flex-col bg-gray-50 rounded-lg shadow-md p-4 ${className} ${borderStyle}`, children: [_jsx("div", { className: "flex items-center justify-between mb-4", children: _jsxs("div", { className: "flex items-center", children: [_jsx("h3", { className: "font-semibold text-gray-900", children: taskState.label }), _jsx("span", { className: "ml-2 bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full", children: tasksState?.length || 0 })] }) }), _jsx("div", { className: "flex-grow flex flex-col gap-2 border-t pt-4 border-gray-200", children: tasksState.map(task => (_jsx(TaskCard, { task: task, onAdvance: onAdvanceTask, loading: loading }, task.id))) })] }));
};
export default KanbanColumn;
